exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card{\n    border-radius: 5px;\n    width: 120px;\n    height: 100px;\n}\n.card-online{\n    border-radius: 5px;\n    width: 120px;\n    height: 100px;\n    background: #53d5f7; \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/dashboard/dashboardinfo/dashboardinfo.component.css
// module id = ../../../../../src/app/components/pages/dashboard/dashboardinfo/dashboardinfo.component.css
// module chunks = main